import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
/**
* @public
*/
const CopyIcon = /* @__PURE__ */ forwardRef(function(props, ref) {
	return /* @__PURE__ */ jsx("svg", {
		"data-sanity-icon": "copy",
		width: "1em",
		height: "1em",
		viewBox: "0 0 25 25",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		ref,
		children: /* @__PURE__ */ jsx("path", {
			d: "M8.5 8.5H5.5V20.5H16.5V16.5M19.5 4.5H8.5V16.5H19.5V4.5Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinejoin: "round"
		})
	});
});
export { CopyIcon, CopyIcon as default };

//# sourceMappingURL=Copy.js.map